import React from 'react';
import './Spinner.scss';

const Spinner = ({ color, backgroundColor }) => {
  return (
    <div className="spinner-container">
      <div 
        className="spinner" 
        style={{ 
          borderTopColor: color, 
          backgroundColor: backgroundColor || '#f3f3f3' // Default background color
        }}></div>
    </div>
  );
};

export default Spinner;

